export type { LikeIconProps } from './LikeIcon';
export { LikeIcon } from './LikeIcon';
